import React from 'react';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';

export interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  inputClassName?: string;
  onChecked?: () => void;
}

const Radio: React.FC<RadioProps> = ({
  className = '',
  inputClassName = '',
  onChecked,
  children,
  checked,
  onChange,
  ...props
}) => {
  const labelClassName = useClassNames([
    'grid place-content-center w-20 h-20 border border-secondary-regular rounded-full',
    className,
  ]);

  const inputClassNames = useClassNames(['h-12 w-12 border-0 text-secondary-regular', inputClassName]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
    onChecked?.();
  };

  const { id, ...rest } = props;

  return (
    <label className={labelClassName} htmlFor={id} data-testid="atom-radio">
      <input
        id={id}
        style={{ background: checked ? '#494949' : 'white' }}
        className={inputClassNames}
        type="radio"
        checked={checked}
        onChange={(e) => handleChange(e)}
        {...rest}
        data-testid={(props as { 'data-testid'?: string })['data-testid'] ?? 'atom-radio-input'}
      />
      {children}
    </label>
  );
};

export default Radio;
